<template>
  <div class="main-wrapper">
  <nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top" id="sideNav">
    <a class="navbar-brand js-scroll-trigger" href="#about">
      <span class="d-block d-lg-none">Aaron Were</span>
      <span class="d-none d-lg-block">
        <img class="img-fluid img-profile rounded-circle mx-auto mb-2" src="./assets/img/profile.jpg" alt="">
      </span>
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#about">
          <font-awesome-icon icon="coffee" /> About</a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#experience">
          <font-awesome-icon icon="briefcase" /> Experience</a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#education">
          <font-awesome-icon icon="graduation-cap" /> Education</a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#skills">
          <font-awesome-icon icon="compass" /> Skills</a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#interests">
          <font-awesome-icon icon="dice-d6" /> Interests</a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#awards">
          <font-awesome-icon icon="award" /> Awards</a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#affiliations">
          <font-awesome-icon icon="address-card" /> Affiliations</a>
        </li>
      </ul>
    </div>
  </nav>
  <div class="container-fluid p-0">
    <section class="resume-section p-3 p-lg-5 d-flex align-items-center" id="about">
      <div class="w-100">
        <h1 class="mb-0">{{ name }}
        <span class="text-primary">{{ surname }}</span>
        </h1>
        <div class="subheading mb-5">
          <a :href="link"><font-awesome-icon :icon="['fas','envelope']" /> {{ address }}</a>
        </div>
        <p class="lead mb-5"><span v-html="aboutMe"></span></p>
        <div class="social-icons">
          <a href="https://www.linkedin.com/in/aaronwere/">
            <font-awesome-icon :icon="['fab','linkedin']"/>
          </a>
          <a href="https://github.com/clonemeagain/">
            <font-awesome-icon :icon="['fab','github']"/>
          </a>
          <a href="https://twitter.com/TheDreadCthulhu">
            <font-awesome-icon :icon="['fab','twitter']"/>
          </a>
        </div>
      </div>
    </section>
    <hr class="m-0">
    <section class="resume-section p-3 p-lg-5 d-flex justify-content-center" id="experience">
      <div class="w-100">
        <h2 class="mb-5">Experience</h2>
        <div class="resume-item d-flex flex-column flex-md-row justify-content-between mb-5" v-for="job in experience" :key="job.description">
          <div class="resume-content mr-auto">
            <h3 class="mb-0">{{ job.position }}</h3>
            <div class="subheading mb-3"><a :href="job.url">{{ job.company }}</a></div>
            <p>{{job.description}}</p>
          </div>
          <div class="resume-date text-md-right">
            <span class="text-primary">{{job.startDate}} - {{job.endDate}}</span>
          </div>
        </div>
      </div>
    </section>
    <hr class="m-0">
    <section class="resume-section p-3 p-lg-5 d-flex align-items-center" id="education">
      <div class="w-100">
        <h2 class="mb-5">Education</h2>
        <div class="resume-item d-flex flex-column flex-md-row justify-content-between mb-5" v-for="t in education" >
          <div class="resume-content">
            <h3 class="mb-0"><a :href="t.url">{{ t.school }}</a></h3>
            <div class="subheading mb-3">{{ t.course }}</div>
          </div>
          <div class="resume-date text-md-right">
            <span class="text-primary">{{ t.dateCompleted }}</span>
          </div>
        </div>
      </div>
    </section>
    <hr class="m-0">
    <section class="resume-section p-3 p-lg-5 d-flex align-items-center" id="skills">
      <div class="w-100">
        <h2 class="mb-5">Skills</h2>
        <div class="subheading mb-3">Programming Languages &amp; Tools</div>
        <ul class="list-inline dev-icons">
          <li class="list-inline-item">
            <span class="devicons devicons-html5" title="HTML"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-python" title="Python"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-css" title="CSS"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-javascript" title="Javascript"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-nodejs" title="NodeJS"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-sass" title="SASS"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-less" title="LESS"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-wordpress" title="Wordpress"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-gulp" title="Gulp"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-grunt" title="Grunt"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-npm" title="NPM"></span>
          </li>
          <li class="list-inline-item">
            <font-awesome-icon :icon="['fab','vuejs']" title="VueJS"/>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-drupal" title="Drupal"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-java" title="java"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-php" title="PHP"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-github_badge" title="Github"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-markdown" title="Markdown"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-symfony" title='Symfony'></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-mysql" title="MySQL & MariaDB"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-jquery" title="jQuery"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-bootstrap" title="Bootstrap"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-bower" title="Bower"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-cisco" title="Cisco"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-windows" title="Windows"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-linux" title="Linux"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-ubuntu" title="Ubuntu"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-android" title="Android"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-stackoverflow" title="Stackoverflow"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-google_drive" title="Google Drive"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-raspberry_pi" title="Raspberry Pi"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-redis" title="Redis"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-opensource" title="OpenSource"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-nginx" title="NGinX"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-gnu" title="GNU"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-debian" title="Debian"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-composer" title="Composer"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-terminal" title="Terminal"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-code" title="Code"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-responsive" title="Responsive"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-eclipse" title="Eclipse"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-sublime" title="SublimeText"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-aws" title="AWS"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-google-cloud-platform" title="Google Cloud Platform"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-docker" title="Docker"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-vim" title="Vim"></span>
          </li>
          <li class="list-inline-item">
            <span class="devicons devicons-kubernetes" title="Vim"></span>
          </li>
        </ul>
        <div class="subheading mb-3">Workflow</div>
        <ul class="fa-ul mb-0">
          <li>
          I don't claim to be an expert on every language and technology, however I have good familiarity and I have used the listed stacks to build production services.</li>
          <br />
          <li v-for="flow in workflowitems">
            <font-awesome-icon icon="check" :style="{color: 'green'}" />
          {{flow}}</li>
          <li>
            <li><font-awesome-icon icon="check" :style="{color: 'green'}" /> I'm also quite skilled with Mikrotik, I'm a massive fan of their work! <br style="margin-bottom:10px;"/>
              <a href="https://www.mikrotik.com"><img src="./assets/img/logo.svg" title="Mikrotik Uncertified Networking Engineer" style="height:50px;"/>
              </a>
            </li>
          </ul>
        </div>
      </section>
      <hr class="m-0">
      <section class="resume-section p-3 p-lg-5 d-flex align-items-center" id="interests">
        <div class="w-100">
          <h2 class="mb-5">Interests</h2>
          <p v-for="i in interests"><span v-html="i"></span></p>
        </div>
      </section>
      <hr class="m-0">
      <section class="resume-section p-3 p-lg-5 d-flex align-items-center" id="awards">
        <div class="w-100">
          <h2 class="mb-5">Awards &amp; Certifications</h2>
          <ul class="fa-ul mb-0">
            <li v-for="cert in certifications">
              <font-awesome-icon icon="award"  :style="{ color: 'gold' }"/>
              {{cert}}
            </li>
          </ul>
        </div>
      </section>
      <hr class="m-0">
      <section class="resume-section p-3 p-lg-5 d-flex align-items-center" id="affiliations">
        <div class="w-100">
          <h2 class="mb-5">Affiliations</h2>
          <ul class="fa-ul mb-0">
            <li v-for="org in affiliations">
              <font-awesome-icon icon="address-card" :style="{ color: 'green' }"/>
              <a :href="org.site" :title="org.name">{{org.name}}</a>
            </li>
          </ul>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: 'My portfolio',
      name: 'Aaron',
      surname: 'Were',
      address: 'clonemeagain@gmail.com',
      aboutMe: 'Full stack software developer with experience in systems engineering both on-prem and in the cloud. This site built with <a href="https://vuejs.org/">VueJS</a> and hosted by <a href="https://aws.amazon.com">AWS</a> & <a href="https://cloudflare.com">CloudFlare</a>. I like a nice strong macchiato!',

      experience: [
        {
          position: 'IT Manager & Programmer',
          company: 'TDJ Australia Pty Ltd',
          url: 'https://tdj.com.au',
          description: 'Managing the IT Department, develop new applications and maintain existing web properties. Building solutions with Google Kubernetes Engine, Amazon Lambda and EC2/RDS etc, with on-prem servers and services.',
          startDate: '2019',
          endDate: 'present'
        },
        {
          position: 'IT Systems Administrator',
          company: 'TDJ Australia Pty Ltd',
          url: 'https://tdj.com.au',
          description: 'Infrastructure administration, user-support, server hardware and networking',
          startDate: '2012',
          endDate: '2019'
        },
        {
          position: 'Field Engineer',
          company: 'BT Openreach - Scotland',
          url: 'https://www.openreach.co.uk',
          description: 'Responsible for installing, maintaining and repairing telecommunications infrastructure in challenging environments.',
          startDate: '2010',
          endDate: '2012'
        },
        {
          position: 'Systems Administrator',
          company: 'Netafim Australia',
          url: 'https://www.netafim.com.au',
          description: 'Maintaining infrastructure, backups, user-support and application development',
          startDate: '2007',
          endDate: '2010'
        }
      ],
      education: [
        {
          school: 'Victoria University - Melbourne Australia',
          course: 'Advanced Diploma of Computer Systems Engineering',
          dateCompleted: '2007',
          url: 'https://www.vu.edu.au/'
        },
        {
          school: 'Waikato University - Hamilton NZ',
          course: 'Batchelor of Management & Computer Science',
          dateCompleted: '',
          url: 'https://www.waikato.ac.nz'
        }
      ],     
      interests: [
        'An avid gamer, I love to crawl around in virtual worlds and annihilate demon hordes, while stealing their treasure!',
        'I spend a lot of time volunteering for the <a href="https://ses.vic.gov.au">Victoria State Emergency Service</a>, in both operational and non-operational roles with the admin and training teams for our unit.',
        'I am an avid reader, and spend far too much on novels, audiobooks and ebooks (ask about my kindle!)',
        'I love my Dog, and we walk for miles every morning, she is not a fan of the time I spend working on Open Source projects, as I tend to get into the zone and not give enough pats.',
        'Spent a lot of time developing plugins for osTicket, we started using it at work, and I was enjoying myself making things in my spare time that made it better. Other people seem to like my work as well, loads of stars on GitHub for them. '
      ],
      workflowitems: [
      'Mobile-First, Responsive Design, Full-Stack Engineering',
      'Cross-browser testing & debugging','Cross-functional teams',
      'Project Management', 'Leading small teams', 'Agile & Waterfall development',
      'Systems Engineering'
      ],
      certifications: [
      'Google Cloud Certified Developer',
      'AWS Training',
        'Coxswain of Rescue Boat - VICSES 2018',
        'Rescue, Search, Navigation, Chainsawing, Working @ height, EVS, Boating & Swift Water  - VICSES',
        'Medium Rigid Truck License - VicRoads 2018',
        'Project Management Training attendance cetificate - yay',
        'UK Driving License & OSHA card',
        'Advanced Diploma of Computer Systems Engineering - VUT Melbourne 2007',
        'Incomplete Batchelor of Management Studies & Computer Science - Waikato University NZ 2001'
      ],
      affiliations: [
        {
          name: 'ITPA - IT Professionals Association of Australia - Professional Member',
          site: 'https://itpa.org.au',
        },{
          name: 'Linux Australia - Mailling list Volunteer Moderator',
          site: 'https://linux.org.au/'
        },
        {
          name: 'VICSES - The Victoria State Emergency Service - Operational Member/Volunteer',
          site: 'https://ses.vic.gov.au'
        },
        {
          name: 'osTicket - Open Source Ticketing System - Plugin Developer',
          site: 'https://osticket.com'
        }
      ]
    }
  },
  computed: { 
    link: function() {
      // Oh good.
      return 'mailto:' + this.address
    }
  },
  mounted () {
    const $ = this.jquery

    // run the following when VueJS decides.. frustrating, but it works:
    this.$nextTick(() => {
      $('.js-scroll-trigger').on('click',function() {
        $('.navbar-collapse').collapse('hide');
      });
    })
  }
}
</script>

<style>
/*!
 * Start Bootstrap - Resume v5.0.3 (https://startbootstrap.com/template-overviews/resume)
 * Copyright 2013-2019 Start Bootstrap
 * Licensed under MIT (https://github.com/BlackrockDigital/startbootstrap-resume/blob/master/LICENSE)
 */
body {
  font-family: 'Muli', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  padding-top: 54px;
  color: #868e96;
}

@media (min-width: 992px) {
  body {
    padding-top: 0;
    padding-left: 17rem;
  }
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Saira Extra Condensed', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  font-weight: 700;
  text-transform: uppercase;
  color: #343a40;
}

h1 {
  font-size: 6rem;
  line-height: 5.5rem;
}

h2 {
  font-size: 3.5rem;
}

h3 {
  font-size: 2rem;
}

p.lead {
  font-size: 1.15rem;
  font-weight: 400;
}

.subheading {
  text-transform: uppercase;
  font-weight: 500;
  font-family: 'Saira Extra Condensed', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  font-size: 1.5rem;
}

.social-icons a {
  display: inline-block;
  height: 3.5rem;
  width: 3.5rem;
  background-color: #495057;
  color: #fff !important;
  border-radius: 100%;
  text-align: center;
  font-size: 1.5rem;
  line-height: 3.5rem;
  margin-right: 1rem;
}

.social-icons a:last-child {
  margin-right: 0;
}

.social-icons a:hover {
  background-color: #BD5D38;
}

.dev-icons {
  font-size: 3rem;
}

.dev-icons .list-inline-item i:hover {
  color: #BD5D38;
}

#sideNav .navbar-nav .nav-item .nav-link {
  font-weight: 800;
  letter-spacing: 0.05rem;
  text-transform: uppercase;
}

#sideNav .navbar-toggler:focus {
  outline-color: #d48a6e;
}

@media (min-width: 992px) {
  #sideNav {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 17rem;
    height: 100vh;
  }
  #sideNav .navbar-brand {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: auto auto 0;
    padding: 0.5rem;
  }
  #sideNav .navbar-brand .img-profile {
    max-width: 10rem;
    max-height: 10rem;
    border: 0.5rem solid rgba(255, 255, 255, 0.2);
  }
  #sideNav .navbar-collapse {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    width: 100%;
    margin-bottom: auto;
  }
  #sideNav .navbar-collapse .navbar-nav {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 100%;
  }
  #sideNav .navbar-collapse .navbar-nav .nav-item {
    display: block;
  }
  #sideNav .navbar-collapse .navbar-nav .nav-item .nav-link {
    display: block;
  }
}

section.resume-section {
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
  max-width: 75rem;
}

section.resume-section .resume-item .resume-date {
  min-width: none;
}

@media (min-width: 768px) {
  section.resume-section {
    min-height: 100vh;
  }
  section.resume-section .resume-item .resume-date {
    min-width: 18rem;
  }
}

@media (min-width: 992px) {
  section.resume-section {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
}

#sideNav.bg-primary {
  background-color: #BD5D38 !important;
}

section .text-primary {
  color: #BD5D38 !important;
}

section a {
  color: #BD5D38 !important;
}

section a:hover, a:focus, a:active {
  color: #824027;
}
</style>


// WEBPACK FOOTER //
// src/App.vue